module.exports = __webpack_public_path__ + "img/blog-8.e879f544.webp";